import { render, staticRenderFns } from "./CompanyPNL.vue?vue&type=template&id=448d405a"
import script from "./CompanyPNL.vue?vue&type=script&lang=js"
export * from "./CompanyPNL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports